module.exports = __webpack_public_path__ + "static/media/purple-heart.bfdb3ebe.svg";